import React from "react";
import { Box, Heading, Text, SimpleGrid, Image } from "@chakra-ui/react";
import card1Img from "../assets/card1.png"; // Atualize conforme necessário
import card2Img from "../assets/card2.png"; // Atualize conforme necessário
import card3Img from "../assets/card3.png"; // Atualize conforme necessário

const ServicesSection = () => {
  return (
    <Box py={10} bg="gray.50" display="flex" justifyContent="center" height={{ base: "auto", lg: "92vh" }}>
      <Box w={{ base: "100%", lg: "70%" }}>
        <Box textAlign="center" mb={10}>
          <Heading as="h3" size="md" mb={4} color="gold.500">
            SOLUÇÕES INOVADORAS EM EMPILHADEIRAS
          </Heading>
          <Heading as="h3" size="xl" mb={4} color="black">
            Maximize a eficiência com nosso expertise
          </Heading>
        </Box>
        <SimpleGrid columns={{ base: 1, md: 1, lg: 3 }} spacing={10}>
          {[
            { img: card1Img, title: "Venda de Peças", text: "Trabalhamos com as melhores peças do mercado" },
            { img: card2Img, title: "Manutenção Preventiva, Corretiva e Contratos", text: "Equipe qualificada e ferramentas de diagnóstico e reparos de excelência" },
            { img: card3Img, title: "Locação e Venda", text: "Trabalhamos com as melhores marcas do mercado" }
          ].map((card, index) => (
            <Box
              key={index}
              bg="white"
              boxShadow="md"
              borderRadius="md"
              overflow="hidden"
              _hover={{ transform: "scale(1.05)", transition: "transform 0.3s" }}
            >
              <Image src={card.img} alt={card.title} />
              <Box p={5}>
                <Heading as="h3" size="md" mb={3} color="black" _hover={{ color: "gold.500", transition: "color 0.3s" }}>
                  {card.title}
                </Heading>
                <Text fontSize="lg" color="gray.800">
                  {card.text}
                </Text>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default ServicesSection;
